// Siblings follow the order the server gave them, where it gave one. A school's own order and the
// order the backend builds both arrive as sortOrder. Everything else keeps the rules that were
// already here: the pinned order field first, then year groups by their number, then by name.
export const compareGroupFilterSiblings = (left, right) => {
    if (left.sortOrder && right.sortOrder) {
        return left.sortOrder - right.sortOrder;
    }

    if (left.order != null && right.order != null) {
        return left.order - right.order;
    }

    if (left.order != null) {
        return -1;
    }

    if (right.order != null) {
        return 1;
    }

    const leftYear = readYearGroupNumber(left.name);
    const rightYear = readYearGroupNumber(right.name);

    if (leftYear != null && rightYear != null) {
        return leftYear - rightYear;
    }

    if (left.name > right.name) {
        return 1;
    }

    return right.name > left.name ? -1 : 0;
};

const readYearGroupNumber = name => {
    if (!name?.startsWith('Year ')) {
        return null;
    }

    const digits = name.match(/\d+/);

    return digits ? parseInt(digits[0], 10) : null;
};
